<template>
  <div>
    <topbar
      :titulo="$t('FINANCEIRO.RELATORIO_PAGAMENTOS')"
      :subtitulo="$t('FINANCEIRO.RELATORIO_PAGAMENTOS_DESCRICAO')"
      :breadcrumbs="breadcrumbs"
    />

    <b-row>
      <b-col md="3">
        <input-select-search
          ref="anoLetivoId"
          v-model="localFiltro.anoLetivoId"
          :label="$t(`ACADEMICO.ANO_LETIVO`)"
          :options="opcoes.anosLetivos"
          required
        />
      </b-col>
      <b-col md="3">
        <input-select-search
          ref="matriculaId"
          v-model="localFiltro.matriculaId"
          :label="$t(`ACADEMICO.MATRICULA`)"
          :options="opcoes.matriculas"
          :isDisabled="true"
          required
        />
      </b-col>
      <b-col md="auto">
        <b-button
          class="botao-acao-filtro mb-3 w-100"
          variant="info"
          @click="filtrar"
        >
          {{ $t('GERAL.GERAR_RELATORIO') }}
        </b-button>
      </b-col>
      <b-col md="auto">
        <b-button
          class="botao-acao-filtro w-100"
          variant="secondary"
          @click="limparFiltro"
        >
          {{ $t('GERAL.LIMPAR') }}
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>
    
<script>
// Utils & Aux:
import mensagem from '@/common/utils/mensagem';
import { START_LOADING, STOP_LOADING } from '@/store/Store';
import pdf from '@/common/utils/pdf';
import breadcrumb from '@/common/utils/breadcrumb';
import { InputSelectSearch } from '@/components/inputs';
import helpers from '@/common/utils/helpers';

// Services:
import AnoLetivoService from "@/common/services/ano-letivo/ano-letivo.service";
import FluxoCaixaService from '@/common/services/fluxo-caixa/fluxo-caixa.service.js';
import Permissoes from '@/components/mixins/permissoes';
import { BUSCAR_ALUNO_SELECIONADO } from '@/store/autenticacao.module';
// Components:
import Topbar from '@/layouts/full-layout/horizontal-sidebar/Topbar.vue';

export default {
  name: 'RelatorioPagamentos',
  mixins: [Permissoes],
  data() {
    return {
      localFiltro: {
        anoLetivoId: '',
        matriculaId: '',
      },
      opcoes: {
        anosLetivos: [],
        matriculas: [],
      },
      breadcrumbs: [
        { titulo: this.$t('FINANCEIRO.FINANCEIRO') },
        { titulo: this.$t('FINANCEIRO.RELATORIO_PAGAMENTOS') },
      ],
    }
  },
  components: {
    Topbar,
    InputSelectSearch,
  },
  mounted() {
    breadcrumb.definir(this.$store, [
      { titulo: this.$t('FINANCEIRO.FINANCEIRO') },
      { titulo: this.$t('FINANCEIRO.RELATORIO_PAGAMENTOS') },
      ]);

    this.listarAnosLetivos();
    this.buscarAlunoSelecionado();
  },
  methods: {
    buscarAlunoSelecionado() {
      this.$store.dispatch(BUSCAR_ALUNO_SELECIONADO).then((data) => {
        this.localFiltro.matriculaId = data.matriculaId;
        this.opcoes.matriculas = [
          {
            text: `${data.matriculaCodigo} - ${data.nome}`,
            value: data.matriculaId,
          },
        ];
      });
    },
    gerarRelatorioPdf() {
      this.$store.dispatch(START_LOADING);
      const matriculaId = this.localFiltro.matriculaId;
      const anoLetivoId = this.localFiltro.anoLetivoId;

      FluxoCaixaService.gerarImpostoDeRendaPdf(matriculaId, anoLetivoId)
        .then(({ data }) => {
          if (data.documento) {
            let bytes = pdf.base64ToArrayBuffer(data.documento);
            let blob = new Blob([bytes], { type: 'application/pdf' });
            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = data.nomeArquivo;
            link.click();
          }
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    listarAnosLetivos() {
      this.$store.dispatch(START_LOADING);
      AnoLetivoService.listar()
        .then(({ data }) => {
          data = data.map((row) => {
            return {
              ...row,
              text: row.ano,
              value: row.id,
            };
          });

          this.opcoes.anosLetivos = data;
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    validarFiltro() {
      return helpers.validarFormulario(this.$refs);
    },
    filtrar() {
      if (!this.validarFiltro()) return;
      this.gerarRelatorioPdf();
    },
    limparFiltro() {
      this.localFiltro = {
        anoLetivoId: '',
        matriculaId: this.localFiltro.matriculaId,
      };
      this.$emit('limpar', this.localFiltro);
    },
  },
};
</script>
    